import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../utils/app_consts";

const initialState = {
 retrieve_goods_received_details: { message: "idle" },
};

export const retrieve_goods_received_details_Slice = createSlice({
 name: "retrieve_goods_received_details",
 initialState,
 reducers: {
  success_retrieve_goods_received_details: (state, action) => {
   state.retrieve_goods_received_details = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_retrieve_goods_received_details: (state, action) => {
   state.retrieve_goods_received_details = { status: app_consts.FAIL, message: action.payload };
  },
  reset_retrieve_goods_received_details: (state) => {
   state.retrieve_goods_received_details = { status: app_consts.IDLE };
  },
  loading_retrieve_goods_received_details: (state) => {
   state.retrieve_goods_received_details = { status: app_consts.LOADING };
  },
 }
});

export const { success_retrieve_goods_received_details, fail_retrieve_goods_received_details, reset_retrieve_goods_received_details, loading_retrieve_goods_received_details } = retrieve_goods_received_details_Slice.actions;

export default retrieve_goods_received_details_Slice.reducer;